import axiosInstance from '../initializers/axios';

export const toAbsoluteApiUrl = (url?: string | null) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:') || url.startsWith('data:')) return url;

  const path = url.startsWith('/') ? url : `/${url}`;
  const envBase = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (envBase) {
    if (envBase.endsWith('/api') && path.startsWith('/api/')) return `${envBase}${path.slice(4)}`;
    return `${envBase}${path}`;
  }

  const axiosBase = (axiosInstance.defaults.baseURL || '').trim().replace(/\/+$/, '');
  if (axiosBase) {
    if (axiosBase.endsWith('/api') && path.startsWith('/api/')) return `${axiosBase}${path.slice(4)}`;
    return `${axiosBase}${path}`;
  }

  return path;
};

export const buildEntityFileUrl = (entityId?: number | null, entityType?: number | null) => {
  if (!entityId || !entityType) return '';
  /*
   * PORT NOTE — the media service does not exist yet, and the id shape changed with it.
   *
   * The monolith served media from `/api/upload/download` on the API host; Architecture 5.0
   * reserves `media/*` under the Platform API base, so the path is now relative and
   * `toAbsoluteApiUrl` prefixes it with `axiosInstance.defaults.baseURL`
   * (`/api/v1/platform`). Every reference in the ported tree goes through this helper or the
   * `file` group in `ApiConstants`, so the eventual service has one agreed prefix instead of a
   * scattering of legacy URLs.
   *
   * Today the request 404s and the `<img>` renders nothing, which is the honest outcome: a
   * Platform identity is a GUID while the ported shell still supplies the legacy numeric
   * `IUser.id` (the bridge maps it to 0), so no media object can be addressed anyway. See gap 1
   * in `Architech-Upgrade 5.0/07-component-ownership-platform-vs-restaurant.md` §6.5.
   */
  return toAbsoluteApiUrl(`/media/download?entityId=${entityId}&entityType=${entityType}`);
};

export default buildEntityFileUrl;
